<template>
  <div class="container">
    <h4 class="title is-4">{{chartName}}</h4>
    <app-chart-time-frames :graphTemplateId="object.graph_template_id"></app-chart-time-frames>
    <div id="chartdiv" :class="chartClassName"></div>
    <div class="buttons" style="margin-top: 2.5rem;">
      <b-button type="is-primary" class="is-small" @click="handleClickViewEvents">View Events</b-button>
      <b-button type="is-secondary" class="is-small" @click="handleClickEditObject">Edit Object</b-button>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import {beautifyObjectName} from "../utils/utils";
  /* eslint-disable */
  import * as am4core from "@amcharts/amcharts4/core";
  /* eslint-disable */
  import * as am4charts from "@amcharts/amcharts4/charts";
  /* eslint-disable */
  import am4themes_dark from "@amcharts/amcharts4/themes/dark";
  import ChartTimeFrames from '../components/ChartTimeFrames';
  import BButton from "buefy/src/components/button/Button";

  export default {
    name: "screen-chart",
    components: {
      BButton,
      appChartTimeFrames: ChartTimeFrames
    },
    data() {
      return {
        firstChange: true,
        object: null,
        chart: null,
        colorSet: null,
        chartClassName: 'chart'
      };
    },
    watch: {
      selectedTimeFrameId(value, previous) {
        if (parseInt(value) !== parseInt(previous)) {
          const that = this;
          this.fetchGraph({
            objectId: this.object.id,
            timeFrameId: this.selectedTimeFrameId,
            useOverlay: false,
            cb: (err, data) => {
              if (err) {
                return console.log(err);
              }

              console.log(data);
              that.chart.data = data['data'];
            }
          });

          this.firstChange = false;
        }
      }
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('objects', ['objectById']),
      ...mapGetters('graphs', ['graphTemplates', 'graph']),
      ...mapGetters('events', ['selectedTimeFrameId', 'selectedTimeFrame']),
      chartName() {
        if (!this.object) {
          return 'Unknown Chart';
        }

        return beautifyObjectName(this.object.name);
      },
      chartData() {
        return [];
      }
    },
    methods: {
      ...mapActions('graphs', ['fetchGraph']),
      ...mapMutations('ui', ['SHOW_OVERLAY', 'HIDE_OVERLAY']),
      initChartGantt(initialData) {
        this.chart = am4core.create("chartdiv", am4charts.XYChart);
        this.chart.padding(0, 15, 0, 15);
        this.chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm";
        this.chart.data = initialData ? initialData : [];

        let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.inversed = true;

        let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.dateFormatter.dateFormat = "yyyy-MM-dd HH:mm";
        dateAxis.renderer.minGridDistance = 70;
        dateAxis.baseInterval = { count: 30, timeUnit: "minute" };
        dateAxis.max = new Date().getTime();
        dateAxis.strictMinMax = true;
        dateAxis.renderer.tooltipLocation = 0;

        let series1 = this.chart.series.push(new am4charts.ColumnSeries());
        series1.columns.template.width = am4core.percent(80);
        series1.columns.template.tooltipText = "{duration}";

        series1.dataFields.openDateX = "fromDate";
        series1.dataFields.dateX = "toDate";
        series1.dataFields.categoryY = "category";
        series1.columns.template.propertyFields.fill = "color"; // get color from data
        series1.columns.template.propertyFields.stroke = "color";
        series1.columns.template.strokeOpacity = 1;

        this.chart.scrollbarX = new am4core.Scrollbar();

        this.chartClassName = 'chart gantt';

        this.chart.events.on('ready', () => {
          this.handleChartReady();
        });
      },
      initChartLiniar(initialData) {
        this.chart = am4core.create("chartdiv", am4charts.XYChart);
        this.chart.padding(0, 15, 0, 15);
        this.chart.data = initialData ? initialData : [];

        // Create axes
        let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "date";
        categoryAxis.renderer.minGridDistance = 50;
        categoryAxis.renderer.grid.template.location = 0.5;
        categoryAxis.startLocation = 0.5;
        categoryAxis.endLocation = 0.5;
        categoryAxis.renderer.labels.template.disabled = true;

        // Create value axis
        let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.baseValue = 0;

        // Create series
        let series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "date";
        series.strokeWidth = 2;
        // series.tensionX = 0.77;

        // bullet is added because we add tooltip to a bullet for it to change color
        let bullet = series.bullets.push(new am4charts.Bullet());
        bullet.tooltipText = "{valueY}";

        bullet.adapter.add("fill", function (fill, target) {
          if (target.dataItem.valueY < 0) {
            return am4core.color("#FF0000");
          }
          return fill;
        });
        let range = valueAxis.createSeriesRange(series);
        range.value = 0;
        range.endValue = -1000;
        range.contents.stroke = am4core.color("#FF0000");
        range.contents.fill = range.contents.stroke;

        // Add scrollbar
        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        scrollbarX.scrollbarChart.xAxes.getIndex(0).renderer.labels.template.disabled = true;
        this.chart.scrollbarX = scrollbarX;

        this.chart.cursor = new am4charts.XYCursor();

        this.chart.events.on('ready', () => {
          this.handleChartReady();
        });
      },
      initChart() {
        am4core.useTheme(am4themes_dark);

        if (this.graph.graphTemplate.id === 1 || this.graph.graphTemplate.id === 2 || this.graph.graphTemplate.id === 4) {
          this.initChartLiniar(this.graph.data);
        } else if (this.graph.graphTemplate.id === 3) {
          this.initChartGantt(this.graph.data);
        } else {
          /* eslint-disable */
          console.log("No template found for this graph.");
          this['HIDE_OVERLAY']();
        }
      },
      handleClickViewEvents() {
        this.$router.push(`/events?objectTypeId=${this.object.object_type_id}&objectId=${this.object.id}&timeFrameId=${this.selectedTimeFrameId}`);
      },
      handleClickEditObject() {
        this.$router.push(`/configure/objects/${this.object.id}`);
      },
      handleChartReady() {
        this['HIDE_OVERLAY']();
      }
    },
    created() {
      this.colorSet = new am4core.ColorSet();
      this.colorSet.saturation = 0.4;
      this.object = this.objectById(this.$route.params.objectId);
    },
    mounted() {
      const that = this;
      this.firstChange = true;
      if (this.graph) {
        this.initChart();
      } else {
        const that = this;
        this.intervalCheckGraphData = setInterval(() => {
          if (that.graph) {
            clearInterval(that.intervalCheckGraphData);
            that.initChart();
          }
        }, 300);
      }
    },
    destroyed() {
      am4core.disposeAllCharts();
    },
    unmounted() {
      am4core.disposeAllCharts();
    }
  }
</script>

<style scoped>
  #chartdiv {
    width: 100%;
    height: 500px;
  }

  @media all and (max-width: 480px) {
    #chartdiv {
      height: 480px;
    }
  }

  #chartdiv.chart.gantt {
    height: 120px;
  }
</style>